let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aqvij")).then(() => parcelRequire('bEuPb'));